module.exports = __webpack_public_path__ + "img/go4.a05c48fd.png";